export default __webpack_public_path__ + "static/media/wtapp.5595c0c4.svg";